<template>
  <div class="container">
    <div class="mainBox">
      <!-- 右上边工具栏,定位 -->
      <div class="topNavRight">
        <div class="searchBox" style="margin-right: 20px">
          <el-input
            placeholder="请输入运单"
            v-model="waybillNumberNoLike"
            class="input-with-select"
          >
            <el-button
              @click="searchWaybillNumber"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </div>
        <div class="topNavItme">
          <img
            class="topnavRightImg"
            src="../assets/img/newImgs/cw_yf_caiWuYingFu.svg"
            alt
          />
          <div class="topnavtext">服务热线: 18922255815</div>
        </div>
        <div class="topNavItme" @click="reloadBtns">
          <img
            class="topnavRightImg"
            src="../assets/img/newImgs/reload.svg"
            alt
            style="width: 24px; height: 20px"
          />
          <div class="topnavtext">刷新</div>
        </div>
      </div>

      <el-tabs
        class="glo_tabs bgc_d7d7d7"
        type="border-card"
        v-model="activeName"
        @tab-click="tabsClick"
      >
        <!-- 首页 -->
        <!-- <el-tab-pane v-if="EnterpriseNo !== 'hs01'" label="首页" name="one">
          <div class="one_top" ref="topIcon">
            <div>
              <div class="groupTitle">业务中心</div>
              <div class="one_group">
                <div class="topItems" v-for="(item, idx) in iconList" :key="idx" @click="goPages(item.jumpUrl)">
                  <div class="one_top_iconBox" :style="'background-color:' + item.bgc">
                    <img class="one_top_icon" :src="item.iconUrl" alt />
                  </div>
                  <div class="ont_top_title">{{ item.name }}</div>
                </div>
              </div>
            </div>

            <div>
              <div class="groupTitle">财务中心</div>
              <div class="one_group">
                <div class="topItems" v-for="(item, idx) in iconList_cw" :key="idx" @click="goPages(item.jumpUrl)">
                  <div class="one_top_iconBox" :style="'background-color:' + item.bgc">
                    <img class="one_top_icon" :src="item.iconUrl" alt />
                  </div>
                  <div class="ont_top_title">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="groupTitle">报表中心</div>
              <div class="one_group">
                <div class="topItems" v-for="(item, idx) in iconList_bb" :key="idx" @click="goPages(item.jumpUrl)">
                  <div class="one_top_iconBox" :style="'background-color:' + item.bgc">
                    <img class="one_top_icon" :src="item.iconUrl" alt />
                  </div>
                  <div class="ont_top_title">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="onw_bottom" :style="'height:' + bottomHeight + 'px'">
          
            <div class="btmItems">
              <div class="btm_item_title btm_item_title_icon">
                <img class="btm_icon" src="../assets/img/newImgs/index_news.svg" alt="消息通知" />
                <div class="btm_item_tit">消息通知</div>
              </div>
              <div class="btm_item_content">
                <div class="cards" v-for="(item, index) in messageDatas" :key="index">
                  <div class="card_row card_tit_top">
                    <div class="card_tit_text">{{ item.title }}</div>
                    <div class="card_tit_time">{{ item.createTime }}</div>
                  </div>
                  <div class="card_row">{{ item.subTitle }}</div>
                  <div v-if="item.isRead == 0" class="btnText">未读</div>
                  <div v-if="item.isRead == 1" class="btnText">已读</div>
                </div>
                <img style="width: 300px; height: 300px; margin: 0 auto" v-if="messageDatas.length == 0" src="../assets/img/newImgs/noData.svg" alt />
              </div>
            </div>

         
            <div class="btmItems">
              <div class="btm_item_title btm_item_title_line">
                <div class="btm_item_tit">企业通知公告</div>
              </div>
              <div class>
                <div class="newRows">
                  <div class="new_left overflow_one">2023年开年工作安排</div>
                  <div class="new_right">2023-1-27</div>
                </div>
              </div>
              <div class="newRows">
                <div class="new_left overflow_one">2023年新年放假通知</div>
                <div class="new_right">2023-1-13</div>
              </div>
              <div class="newRows">
                <div class="new_left overflow_one">效率提高170%！华远助力南方电网打造智能立库，实现仓库24小时不间断黑灯作业</div>
                <div class="new_right">2022-11-25</div>
              </div>
              <div class="newRows">
                <div class="new_left overflow_one">华远软件助力和顺集团,开启汽车零部件供应链数智化管理新篇章</div>
                <div class="new_right">2022-10-08</div>
              </div>
            </div>
          </div>
        </el-tab-pane>-->
        <!-- 业务中心 -->
        <el-tab-pane label="业务中心" name="two">
          <div class="bigTitle">业务中心</div>
          <div class="diagram-panel">
            <business-panel v-if="activeName === 'two'"></business-panel>
          </div>
        </el-tab-pane>

        <el-tab-pane label="财务中心" name="three">
          <div class="bigTitle">财务中心</div>
          <div class="diagram-panel">
            <div class="disFlex">
              <div class="box_lc">
                <!-- 第一行 -->
                <div class="rows">
                  <div class="ts_item">
                    <div class="item" @click="goPages('/FM/MtExpenditure')">
                      <div class="iconBox" style="background-color: #9f9ff8">
                        <img
                          class="itemIcon"
                          src="../assets/img/newImgs/cw_ys_yeWuFeiXaing.svg"
                          alt
                        />
                      </div>
                      <div class="item_right">
                        <div class="mainTitle">业务费项</div>
                      </div>
                    </div>
                  </div>

                  <div class="rowArrow">
                    <div class="rowLine" style="width: 246px"></div>
                    <div class="row_sanjiao"></div>
                  </div>

                  <div
                    class="item item1"
                    @click="goPages('/WaybillManage/ComprehensiveQuery')"
                  >
                    <div class="iconBox color2">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_ys_feiXiangGuoZhang.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">费项过账</div>
                    </div>
                  </div>

                  <div
                    class="item item1 relativeBox"
                    @click="goPages('/FM/FW/OtherExpenses')"
                  >
                    <div class="leftTopLine">
                      <div class="clo_sanjiao leftTopSJ"></div>
                    </div>
                    <div class="iconBox color6">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/yw_fybx.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">费用报销</div>
                    </div>
                  </div>
                </div>

                <!-- 第二行 -->
                <div class="rows">
                  <div class="ts_item" @click="goPages('/FM/BillWriteoff')">
                    <div class="item">
                      <div class="iconBox color4">
                        <img
                          class="itemIcon"
                          src="../assets/img/newImgs/cw_ys_yingShouDuiZhang.svg"
                          alt
                        />
                      </div>
                      <div class="item_right">
                        <div class="mainTitle">应收对账</div>
                      </div>
                    </div>
                    <div class="ts_arrow">
                      <div class="cloArrow">
                        <div class="cloLine"></div>
                        <div class="clo_sanjiao"></div>
                      </div>
                    </div>
                  </div>

                  <div class="rowArrow_f">
                    <div class="row_sanjiao"></div>
                    <div class="rowLine"></div>
                  </div>

                  <div class="item" @click="goPages('/FM/receivableWriteOff')">
                    <div class="iconBox color6">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_ys_caiWuYingShou.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">财务应收</div>
                    </div>
                  </div>

                  <div class="lineBox">
                    <div class="iconStyle1">
                      <div class="styleLeft">
                        <div class="row_sanjiao_left styleLeftIcon"></div>
                      </div>
                      <div class="styleRigth">
                        <div class="row_sanjiao_right styleRightIcon"></div>
                      </div>
                    </div>
                  </div>

                  <div class="item" @click="goPages('/FM/PayableWriteoff')">
                    <div class="iconBox color5">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_yf_caiWuYingFu.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">财务应付</div>
                    </div>
                  </div>
                  <div class="rowArrow">
                    <div class="rowLine"></div>
                    <div class="row_sanjiao"></div>
                  </div>

                  <div class="ts_item" @click="goPages('/FM/BillWriteoff')">
                    <div class="item">
                      <div class="iconBox color1">
                        <img
                          class="itemIcon"
                          src="../assets/img/newImgs/cw_yf_yingFuDuiZhang.svg"
                          alt
                        />
                      </div>
                      <div class="item_right">
                        <div class="mainTitle">应付对账</div>
                      </div>
                    </div>
                    <div class="ts_arrow">
                      <div class="cloArrow">
                        <div class="cloLine"></div>
                        <div class="clo_sanjiao"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 第三行 -->
                <div class="rows">
                  <div class="ts_item" @click="goPages('/FM/InvoicesControl')">
                    <div class="item">
                      <div class="iconBox color7">
                        <img
                          class="itemIcon"
                          src="../assets/img/newImgs/cw_ys_faPiaoGuanLi.svg"
                          alt
                        />
                      </div>
                      <div class="item_right">
                        <div class="mainTitle">发票管理</div>
                      </div>
                    </div>
                  </div>
                  <div class="rowArrow">
                    <div class="rowLine"></div>
                    <div class="row_sanjiao"></div>
                  </div>

                  <div class="item" @click="goPages('/FM/BillWriteoff')">
                    <div class="iconBox color2">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_ys_shouKuanHeXiao.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">收款核销</div>
                    </div>
                  </div>

                  <div class="lineBox">
                    <div class="iconStyle2">
                      <div class="styleLeft">
                        <div class="clo_sanjiao styleLeftIcon"></div>
                      </div>
                      <div class="styleRigth"></div>
                    </div>
                  </div>

                  <div class="item" @click="aaaaa('/FM/BillWriteoff')">
                    <div class="iconBox color3">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_yf_fuKuanHeXiao.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">付款核销</div>
                    </div>
                  </div>
                  <div class="rowArrow_f">
                    <div class="row_sanjiao"></div>
                    <div class="rowLine"></div>
                  </div>

                  <div class="item" @click="goPages('/FM/InvoicesControl')">
                    <div class="iconBox color7">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_yf_faPiaoGuanLi.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">发票管理</div>
                    </div>
                  </div>
                </div>
                <!-- 第四行 -->
                <div class="rows">
                  <div
                    class="item"
                    @click="goPages('/FM/TransportPL')"
                    style="margin-left: 424px"
                  >
                    <div class="iconBox color5">
                      <img
                        class="itemIcon"
                        src="../assets/img/newImgs/cw_yf_heSuanBaoBiao.svg"
                        alt
                      />
                    </div>
                    <div class="item_right">
                      <div class="mainTitle">报表核算</div>
                    </div>
                  </div>
                  <!-- <div class="rowArrow">
                  <div class="rowLine"></div>
                  <div class="row_sanjiao"></div>
                </div>-->
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BusinessPanel from "./BusinessPanel.vue";
export default {
  inject: ["reload"],
  components: { BusinessPanel },
  data() {
    return {
      EnterpriseNo: "",
      waybillNumber: "",
      waybillNumberNoLike: "",
      activeName: "two",
      bottomHeight: 0,

      iconList: [
        {
          name: "新建运单",
          bgc: "#a3a3fc",
          iconUrl: require("@/assets/img/newImgs/yw_xjyd.svg"),
          jumpUrl: "/WaybillManage/WaybillCreate",
        },
        {
          name: "运输规划",
          bgc: "#02a7f0",
          iconUrl: require("@/assets/img/newImgs/yw_ysgh.svg"),
          jumpUrl: "/DispatchCar/TransportationPlann",
        },
        {
          name: "发车配载",
          bgc: "#acd667",
          iconUrl: require("@/assets/img/newImgs/yw_fcpz.svg"),
          jumpUrl: "/DispatchCar/NewStowageAdd",
        },
        {
          name: "调度司机",
          bgc: "#dc62cc",
          iconUrl: require("@/assets/img/newImgs/yw_ddsj.svg"),
          jumpUrl: "/DispatchCar/VehicleStowage",
        },
        {
          name: "司机执行",
          bgc: "#e87fa1",
          iconUrl: require("@/assets/img/newImgs/yw_sjjx.svg"),
          jumpUrl: "/DispatchCar/dispatchCarDetails",
        },
        {
          name: "运单入库",
          bgc: "#d7b938",
          iconUrl: require("@/assets/img/newImgs/yw_ydrk.svg"),
          jumpUrl: "/WarehouseManagement/WarehousingConfirm",
        },
        {
          name: "运单出库",
          bgc: "#6ad988",
          iconUrl: require("@/assets/img/newImgs/yw_ydck.svg"),
          jumpUrl: "/WarehouseManagement/DeliveryConfirm",
        },
        {
          name: "外发管理",
          bgc: "#02a7f0",
          iconUrl: require("@/assets/img/newImgs/yw_wfgl.svg"),
          jumpUrl: "/OutgoingManage/OutgoingManage",
        },
        {
          name: "运单签收",
          bgc: "#dc62cc",
          iconUrl: require("@/assets/img/newImgs/yw_ydqs.svg"),
          jumpUrl: "/WaybillManage/WaybillSigne",
        },
        {
          name: "回单管理",
          bgc: "#acd667",
          iconUrl: require("@/assets/img/newImgs/yw_hdgl.svg"),
          jumpUrl: "/BusinessOrder/ReceiptManage",
        },
        {
          name: "异常管理",
          bgc: "#d7b938",
          iconUrl: require("@/assets/img/newImgs/yw_ycgl.svg"),
          jumpUrl: "/ExceptionManage/ExceptionManage",
        },
        // {
        //   name: "更多应用",
        //   bgc: "#ffffff",
        //   iconUrl: require("@/assets/img/newImgs/moreicon.svg"),
        // },
        // {
        //   name: "财务结算",
        //   bgc: "#a3a3fc",
        //   iconUrl: require("@/assets/img/newImgs/cw_ys_feiXiangGuoZhang.svg"),
        // },
        // {
        //   name: "费用报销",
        //   bgc: "#02a7f0",
        //   iconUrl: require("@/assets/img/newImgs/yw_fybx.svg"),
        // },

        // {
        //   name: "更多应用",
        //   bgc: "#ffffff",
        //   iconUrl: require("@/assets/img/newImgs/moreicon.svg"),
        // },
      ],
      // 财务
      iconList_cw: [
        {
          name: "财务结算",
          bgc: "#a3a3fc",
          iconUrl: require("@/assets/img/newImgs/cw_ys_feiXiangGuoZhang.svg"),
          jumpUrl: "/FM/BillWriteoff",
        },
        {
          name: "费用报销",
          bgc: "#02a7f0",
          iconUrl: require("@/assets/img/newImgs/yw_fybx.svg"),
          jumpUrl: "/FM/OtherExpenses",
        },
        {
          name: "财务应收",
          bgc: "#acd667",
          iconUrl: require("@/assets/img/newImgs/cw_ys_caiWuYingShou.svg"),
          jumpUrl: "/FM/receivableWriteOff",
        },
        {
          name: "财务应付",
          bgc: "#dc62cc",
          iconUrl: require("@/assets/img/newImgs/cw_yf_caiWuYingFu.svg"),
          jumpUrl: "/FM/PayableWriteoff",
        },
        {
          name: "应收对账",
          bgc: "#e87fa1",
          iconUrl: require("@/assets/img/newImgs/cw_ys_yingShouDuiZhang.svg"),
          jumpUrl: "/FM/BillWriteoff",
        },
        {
          name: "应付对账",
          bgc: "#d7b938",
          iconUrl: require("@/assets/img/newImgs/cw_yf_yingFuDuiZhang.svg"),
          jumpUrl: "/FM/BillWriteoff",
        },
        {
          name: "收付款核销",
          bgc: "#6ad988",
          iconUrl: require("@/assets/img/newImgs/cw_yf_feiYongBaoXiao.svg"),
          jumpUrl: "/FM/BillWriteoff",
        },
      ],
      // 报表
      iconList_bb: [
        {
          name: "运单损益",
          bgc: "#a3a3fc",
          iconUrl: require("@/assets/img/newImgs/cw_ys_feiXiangGuoZhang.svg"),
          jumpUrl: "/FM/TransportPL",
        },
        {
          name: "部门损益",
          bgc: "#02a7f0",
          iconUrl: require("@/assets/img/newImgs/yw_fybx.svg"),
          jumpUrl: "/FM/DepartPL",
        },
        {
          name: "应收账款",
          bgc: "#acd667",
          iconUrl: require("@/assets/img/newImgs/cw_ys_caiWuYingShou.svg"),
          jumpUrl: "/FM/BillsDetailed",
        },
        {
          name: "司机押运",
          bgc: "#dc62cc",
          iconUrl: require("@/assets/img/newImgs/cw_yf_caiWuYingFu.svg"),
          jumpUrl: "/FM/DriverEscort",
        },
        {
          name: "装卸费用",
          bgc: "#e87fa1",
          iconUrl: require("@/assets/img/newImgs/cw_ys_yingShouDuiZhang.svg"),
          jumpUrl: "/FM/StevedoreCost",
        },
      ],

      datas: {
        package_add_count: 0, // 包裹今天添加次数
        rejection_count: 0, // 拒收退货次数
        package_no_claim_count: 0, // 包裹未认领次数
        exception_no_handle_count: 0, // 异常未处理处理次数
        exception_handle_count: 0, // 今天异常处理次数
        package_wait_signfor_count: 0, // 到库待签收次数
        package_signfor_count: 0, // 到库签收次数
        package_wait_into_count: 0, // 包裹待入库
        package_into_count: 0, // 包裹入库
        upframe_wait_count: 0, // 待上架
        upframe_count: 0, // 已上架
        storage_stock: 0, // 仓库库存
        storage_wait_pack: 0, // 仓库待打包
        storage_pack: 0, // 仓库打包
        wait_downframe: 0, // 待拣货下架
        downframe: 0, // 拣货下架
        application_pack: 0, // 申请打包
        wait_examine_goods: 0, // 待验货处理
        examine_goods: 0, // 验货处理
        finance_wait_approve: 0, // 财务待审核
        finance_approve: 0, // 财务已审核
        member_wait_payment: 0, // 待付款
        member_payment: 0, // 已付款
        outstorage_wait_confirm: 0, // 待出库确认
        outstorage_confirm: 0, // 已出库确认
        customer_wait_sign: 0, // 客户待签收
        customer_sign: 0, // 客户已签收
      },
      isclick: false, //是否点击过

      messageDatas: [], //消息列表
    };
  },
  created() {
    // this.getData();
    // let uk = window.localStorage.getItem("UserKey") || "";
    // if (!uk) {
    //   this.$router.push("/login");
    // }
    let EnterpriseNo = this.$TOOLS.getEnterpriseNo() || "";
    this.EnterpriseNo = EnterpriseNo;
  },
  mounted() {
    if (this.activeName == "one") {
      this.getMessageList();
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let topHeight = this.$refs.topIcon.offsetHeight; //
      this.bottomHeight = windonHeight - topHeight - 60 - 20 - 41 - 2; //60是顶部高度 20是上下有个10px的margin,41是导航高度,2是预留的
    }
  },
  watch: {
    activeName(a, b) {
      if (a == "one") {
        this.$nextTick(() => {
          let windonHeight =
            document.body.clientHeight || document.documentElement.clientHeight; //页面高度
          let topHeight = this.$refs.topIcon.offsetHeight; //
          this.bottomHeight = windonHeight - topHeight - 60 - 20 - 41 - 2; //60是顶部高度 20是上下有个10px的margin,41是导航高度,2是预留的
        });
        this.getMessageList();
      }
    },
  },
  methods: {
    reloadBtns() {
      this.reload();
    },
    aaaaa() {
      this.$message.error("该功能暂未开放");
    },
    goPages(path) {
      this.$router.push({
        path: path,
      });
    },
    // 消息通知
    getMessageList() {
      let param = {
        pageStart: 1,
        pageTotal: 10,
      };

      this.$API.noticeList(param).then((res) => {
        this.messageDatas = res.data.result.data || [];
      });
    },

    // 点击tabs切换
    tabsClick(e) {
      if (e.name == "one") {
      } else if (e.name == "two") {
      } else if (e.name == "three") {
      }
    },

    getData() {
      Api.getReportCount().then((res) => {
        if (res.data.status == "success") {
          let arrs = res.data.result || [];
          let datas = this.datas;
          for (var k in datas) {
            for (var i = 0; i < arrs.length; i++) {
              if (arrs[i].reportType == k) {
                datas[k] = arrs[i].count;
              }
            }
          }
          this.datas = datas;
        }
      });
    },

    //新建运单
    jumpPages(url) {
      this.$router.push({
        path: url,
      });
    },

    //新建运单
    addPacks() {
      this.$router.push({
        path: "/WaybillManage/WaybillCreateRX",
      });
    },
    //异常处理
    RejectReturn() {
      this.$router.push({
        path: "/ExceptionManage/ExceptionManage",
      });
    },
    //运输计划
    SignFor() {
      this.$router.push({
        path: "/DispatchCar/TransportationPlann",
      });
    },
    //发车配载
    PackageWarehousing() {
      this.$router.push({
        path: "/DispatchCar/NewStowageAdd",
      });
    },
    //调度司机
    PackageShelf() {
      this.$router.push({
        path: "/DispatchCar/VehicleStowage",
      });
    },
    //司机执行
    WarehouseInventory() {
      this.$router.push({
        path: "/DispatchCar/dispatchCarDetails",
      });
    },
    //运单签收
    WarehousePackaging() {
      this.$router.push({
        path: "/WaybillManage/WaybillSigne",
      });
    },
    //外发管理
    PickingOffTheShelf() {
      this.$router.push({
        path: "/OutgoingManage/OutgoingManage",
      });
    },
    //运单出库
    ApplicationPackaging() {
      this.$router.push({
        path: "/WarehouseManagement/DeliveryConfirm",
      });
    },
    //运单入库
    InspectionHandling() {
      this.$router.push({
        path: "/WarehouseManagement/WarehousingConfirm",
      });
    },
    //费用报销
    DeliveryConfirmation() {
      this.$router.push({
        path: "/FM/OtherExpenses",
      });
    },
    //客户签收
    CustomerSignature() {
      this.$router.push({
        path: "/BusinessManagement/ExWarehouse/CustomerSignature",
      });
    },
    //回单管理
    ReceivableBill() {
      this.$router.push({
        path: "/BusinessOrder/ReceiptManage",
      });
    },
    //财务审核
    goWriteOff() {
      this.$router.push({
        path: "/FM/receivableWriteOff",
      });
    },
    searchWaybillNumber() {
      if (!this.waybillNumberNoLike) {
        this.$message.error("请输入运单号");
        return false;
      }
      this.$API
        .wtl_getWaybillList({
          waybillNumberNoLike: this.waybillNumberNoLike,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let lists = res.data.result.data || [];
            if (lists.length) {
              let row = lists[0];
              this.$router.push({
                path: "/WaybillManage/WaybillDetails",
                query: {
                  waybillSplitId: row.waybillSplitId,
                  waybillNumber: row.waybillNumber,
                  orderNumber: row.orderNumber,
                },
              });
            } else {
              this.$message.error("查询不到该运单");
            }
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
  },
};
</script>

<style scoped lang="less">
@borderColor: #ef7c1b;
@bgc_d7d7d7: #d7d7d7;
@linewidth: 80px;

// 设定7种颜色
@color1: #a3a3fc; //淡紫色
@color2: #02a7f0; //蓝色
@color3: #acd667; //
@color4: #dc62cc; //
@color5: #e87fa1; //
@color6: #d7b938; //
@color7: #6ad988; //

.color1 {
  background-color: @color1;
}
.color2 {
  background-color: @color2;
}
.color3 {
  background-color: @color3;
}
.color4 {
  background-color: @color4;
}
.color5 {
  background-color: @color5;
}
.color6 {
  background-color: @color6;
}
.color7 {
  background-color: @color7;
}

.container {
  text-align: center;
  background-color: #fff;
  // position: absolute;
  // top: -10px;
  // left: -10px;

  .mainBox {
    height: calc(100vh - 80px);
    // display: flex;
    // align-items: center;
    overflow: auto;
    // background-color: #d7d7d7;
    position: relative;

    /deep/ .el-tabs__content {
      padding: 0;
    }

    .topNavRight {
      position: absolute;
      z-index: 10;
      right: 0;
      height: 40px;
      display: flex;
      align-items: center;

      .searchBox {
        border-radius: 30px;
        overflow: hidden;

        /deep/ .el-input-group__append,
        .el-input-group__prepend {
          border: none;
          color: #fff;
          background-color: #aaa;
        }
        /deep/ .el-input-group--append .el-input__inner,
        .el-input-group__prepend {
          border: none;
        }
      }

      .topNavItme {
        cursor: pointer;
        height: 30px;
        display: flex;
        align-items: center;
        background-color: #aaaaaa;
        padding: 0 20px;
        color: #fff;
        font-size: 14px;
        border-radius: 30px;
        margin-right: 20px;

        .topnavRightImg {
          width: 20px;
          height: 20px;
        }

        .topnavtext {
          margin-left: 10px;
        }
      }
    }
  }

  .bigTitle {
    font-weight: bold;
    font-size: 26px;
    margin: 10px auto;
    text-decoration: underline;
  }
  .glo_tabs {
    height: 100%;
    overflow: hidden;
  }
  .disFlex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .diagram-panel {
    width: 100%;
    //height: calc(100vh - 245px);
    overflow-y: auto;
  }
  .box_lc {
    // display: inline-block;
    margin: 0 auto;
    // margin-top: 20px;

    .rows {
      display: flex;
      align-items: center;
      margin-bottom: 80px;
      // width: 948px;

      .item1 {
        border: 1px solid @borderColor !important;
      }

      .item {
        cursor: pointer;
        min-width: 140px;
        height: 60px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid @borderColor;
        border: 1px solid @bgc_d7d7d7;
        border-radius: 10px;
        color: #333;
        font-size: 14px;
        transition: All 0.3s ease-in-out;

        .iconBox {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          border-radius: 4px;
        }

        .itemIcon {
          width: 33px;
          height: 33px;
        }

        .item_right {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: flex-start;
          // font-size: 12px;
          // color: #666;

          .mainTitle {
            font-weight: bold;
            display: flex;
          }

          .label {
            margin-top: 4px;
            font-size: 10px;
          }
        }
      }
      .item:hover {
        // background-color: #427ff8;
        font-size: 16px;
        color: @borderColor;
        box-shadow: 2px 2px 10px @borderColor;
        z-index: 10;
        font-weight: bold;
        transform: scale(1.01);
      }

      .ts_item {
        position: relative;
        // 左箭头
        .ts_arrow {
          position: absolute;
          left: 80px;

          .cloArrow {
            display: flex;
            flex-direction: column;
            align-items: center;

            .cloLine {
              width: 2px;
              height: 60px;
              background-color: @borderColor;
            }
          }
        }
      }

      .diaoduImte {
        display: flex;
        width: 400px;
        height: 60px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid @borderColor;
        border: 1px solid @bgc_d7d7d7;
        border-radius: 10px;
        color: #333;
        font-size: 14px;
        transition: All 0.3s ease-in-out;

        .dditem {
          flex: 1;
          color: #4b4bff;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        }
        .dditem:hover {
          font-size: 16px;
          color: @borderColor;
          // box-shadow: 2px 2px 10px @borderColor;
          z-index: 10;
          font-weight: bold;
          transform: scale(1.01);
        }
      }

      // 向下的三角形
      .clo_sanjiao {
        width: 0;
        height: 0;
        border: 10px solid #fff;
        border-top-color: @borderColor;
      }
      // 左边三角
      .row_sanjiao_left {
        width: 0;
        height: 0;
        border: 10px solid #fff;
        border-right-color: @borderColor;
      }
      // 右三角
      .row_sanjiao_right {
        width: 0;
        height: 0;
        border: 10px solid #fff;
        border-left-color: @borderColor;
      }

      .rowArrow1 {
        display: flex;
        align-items: center;

        .rowLine {
          width: @linewidth;
          min-width: 40px;
          height: 2px;
          background-color: #ffffff;
        }

        .row_sanjiao {
          width: 0;
          height: 0;
          border: 10px solid #fff;
          border-left-color: #ffffff;
        }
      }

      //   右箭头
      .rowArrow {
        display: flex;
        align-items: center;

        .rowLine {
          width: @linewidth;
          min-width: 40px;
          height: 2px;
          background-color: @borderColor;
        }

        .row_sanjiao {
          width: 0;
          height: 0;
          border: 10px solid #fff;
          border-left-color: @borderColor;
        }
      }

      //   左箭头
      .rowArrow_f {
        display: flex;
        align-items: center;

        .rowLine {
          width: @linewidth;
          min-width: 40px;
          height: 2px;
          background-color: @borderColor;
        }

        .row_sanjiao {
          width: 0;
          height: 0;
          border: 10px solid #fff;
          border-right-color: @borderColor;
        }
      }
    }
  }
}
// 首页头部功能图标列表
.one_top {
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;

  .one_group {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: auto;

    .topItems {
      margin: 10px 25px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;

      .one_top_iconBox {
        width: 60px;
        height: 60px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        .one_top_icon {
          width: 36px;
          height: 36px;
        }
      }

      .ont_top_title {
        margin-top: 10px;
      }
    }
  }

  .groupTitle {
    font-weight: bold;
    text-align: left;
    padding: 10px 20px 0;
  }
}

.bgc_d7d7d7 {
  /deep/ .el-tabs__nav-scroll {
    background-color: @bgc_d7d7d7;
  }

  /deep/ .el-tabs__item {
    min-width: 100px !important;
  }
}

.onw_bottom {
  background-color: @bgc_d7d7d7;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  text-align: left;
  font-size: 14px;

  border-radius: 4px;

  .btmItems {
    width: calc(50% - 5px);
    height: 100%;
    background-color: #fff;

    .btm_item_title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 16px;
    }

    .btm_item_title_icon {
      display: flex;
      align-items: center;
      .btm_icon {
        width: 16px;
        height: 18px;
      }

      .btm_item_tit {
        margin-left: 10px;
      }
    }

    .btm_item_title_line {
      // border-bottom: 1px solid @bgc_d7d7d7;
      box-sizing: border-box;
      text-align: left;
    }

    .btm_item_content {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }

    .newRows {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 28px;
      line-height: 28px;
      margin: 0 16px;
      box-sizing: border-box;
      cursor: pointer;

      .new_left {
        width: calc(100% - 120px); //80+40
      }
      .new_right {
        width: 80px;
      }
    }
  }
}

.cards {
  background-color: #f4f5f6;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 10px;

  .card_row {
    margin-bottom: 4px;
    cursor: pointer;
  }

  .btnText {
    color: @borderColor;
    font-weight: bold;
    cursor: pointer;
  }

  .card_tit_top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card_tit_text {
      font-weight: bold;
    }
  }
}

.relativeBox {
  position: relative;
  margin-left: 277px;

  .leftTopLine {
    width: 178px;
    height: 110px;
    position: absolute;
    top: 40px;
    left: -180px;
    border-radius: 4px 0 0 0;

    border-top: 2px solid @borderColor;
    border-left: 2px solid @borderColor;

    .leftTopSJ {
      position: absolute;
      left: -10px;
      bottom: 0px;
    }
  }
}

.lineBox {
  position: relative;
  width: 162px;
  height: 1px;
  margin: 0 10px;

  // 向上
  .iconStyle1 {
    position: absolute;
    display: flex;
    top: -121px;

    .styleLeft,
    .styleRigth {
      width: 80px;
      height: 120px;
      border-bottom: 2px solid @borderColor;
      position: relative;
    }
    .styleLeft {
      border-right: 2px solid @borderColor;
      border-radius: 0 0 4px 0;

      .styleLeftIcon {
        position: absolute;
        left: -10px;
        bottom: -10px;
      }
    }
    .styleRigth {
      border-right: none;
      border-radius: 0 0 0 4px;

      .styleRightIcon {
        position: absolute;
        right: -10px;
        bottom: -10px;
      }
    }
  }
  // 向下
  .iconStyle2 {
    position: absolute;
    display: flex;
    bottom: -106px;

    .styleLeft,
    .styleRigth {
      width: 80px;
      height: 105px;
      border-top: 2px solid @borderColor;
      position: relative;
    }
    .styleLeft {
      border-right: 2px solid @borderColor;
      border-radius: 0 4px 0 0;

      .styleLeftIcon {
        position: absolute;
        right: -10px;
        bottom: -10px;
      }
    }
    .styleRigth {
      border-right: none;
      border-radius: 4px 0 0 0;
    }
  }
}
</style>
